import { jsx, jsxs } from 'react/jsx-runtime';
import { isNil } from '@flex-design-system/fx-utils/common';
import { styled } from '@flex-design-system/stitches-react';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Flex } from '../layout/Flex.mjs';
import { Box } from '../utility/layout.mjs';
import { EmptyProvider } from './context.mjs';
import { topSlotRoot, container } from './empty.vanilla.mjs';
import Title$1 from './Subtext.mjs';
import Title from './Title.mjs';

const EmptyImpl = forwardRef(
  ({
    size = "default",
    title,
    subtext,
    topSlot,
    actionSlot,
    className,
    ...props
  }, forwardedRef) => {
    const hasTopSlot = !isNil(topSlot);
    const content = /* @__PURE__ */ jsxs(
      Flex,
      {
        direction: "column",
        align: "center",
        style: { gap: size === "large" ? 16 : 18 },
        children: [
          /* @__PURE__ */ jsxs(
            Flex,
            {
              direction: "column",
              align: "center",
              style: { gap: size === "large" ? 8 : 7 },
              children: [
                title,
                subtext
              ]
            }
          ),
          actionSlot
        ]
      }
    );
    return /* @__PURE__ */ jsx(EmptyProvider, { size, children: /* @__PURE__ */ jsx(
      Container,
      {
        direction: "column",
        justify: "center",
        align: "center",
        ref: forwardedRef,
        className: classNames(container, className),
        ...props,
        children: hasTopSlot ? /* @__PURE__ */ jsxs(
          Flex,
          {
            direction: "column",
            align: "center",
            style: { gap: size === "large" ? 10 : 7 },
            children: [
              /* @__PURE__ */ jsx(Box, { className: topSlotRoot({ size }), children: topSlot }),
              content
            ]
          }
        ) : content
      }
    ) });
  }
);
const Container = styled(Flex);
const Empty = EmptyImpl;
Empty.Title = Title;
Empty.Subtext = Title$1;

export { Empty as default };
//# sourceMappingURL=Empty.mjs.map
